export const translations = {
    EMPLOYEE_ACTIVE_PAGE_NAME: {
        description: 'Visitor Passes Grid',
        primaryValue: 'Visitor Passes',
        stringKey: 'EMPLOYEE_ACTIVE_PAGE_NAME',
    },
    PASS_STATUS_USED: {
        description: 'Used',
        primaryValue: 'Used',
        stringKey: 'PASS_STATUS_USED',
    },
    PASS_STATUS_CANCELED: {
        description: 'Canceled',
        primaryValue: 'Canceled',
        stringKey: 'PASS_STATUS_CANCELED',
    },
    PASS_STATUS_CHECKED_IN: {
        description: 'Checked In status',
        primaryValue: 'Checked In',
        stringKey: 'PASS_STATUS_CHECKED_IN',
    },
    PASS_STATUS_REGISTERED: {
        description: 'Registered',
        primaryValue: 'Registered',
        stringKey: 'PASS_STATUS_REGISTERED',
    },
    PASS_STATUS_DECLINED: {
        description: 'Declined',
        primaryValue: 'Declined',
        stringKey: 'PASS_STATUS_DECLINED',
    },
    PASS_STATUS_DENIED: {
        description: 'Denied',
        primaryValue: 'Denied',
        stringKey: 'PASS_STATUS_DENIED',
    },
    PASS_STATUS_EXPIRED: {
        description: 'Expired',
        primaryValue: 'Expired',
        stringKey: 'PASS_STATUS_EXPIRED',
    },
    PASS_STATUS_INACTIVE: {
        description: 'Inactive',
        primaryValue: 'Inactive',
        stringKey: 'PASS_STATUS_INACTIVE',
    },
    PASS_STATUS_PENDING: {
        description: 'Pending',
        primaryValue: 'Pending',
        stringKey: 'PASS_STATUS_PENDING',
    },
    GRID_HEADER_NAME: {
        description: 'Name',
        primaryValue: 'Name',
        stringKey: 'GRID_HEADER_NAME',
    },
    GRID_HEADER_TYPE: {
        description: 'Type',
        primaryValue: 'Type',
        stringKey: 'GRID_HEADER_TYPE',
    },
    GRID_HEADER_COMPANY: {
        description: 'Company',
        primaryValue: 'Company',
        stringKey: 'GRID_HEADER_COMPANY',
    },
    GRID_HEADER_PASS_TYPE: {
        description: 'Pass Type',
        primaryValue: 'Pass Type',
        stringKey: 'GRID_HEADER_PASS_TYPE',
    },
    GRID_HEADER_PASS_NUMBER: {
        description: 'Pass Number',
        primaryValue: 'Pass Number',
        stringKey: 'GRID_HEADER_PASS_NUMBER',
    },
    GRID_HEADER_STATUS: {
        description: 'Status',
        primaryValue: 'Status',
        stringKey: 'GRID_HEADER_STATUS',
    },
    GRID_HEADER_ACTIONS: {
        description: 'Actions',
        primaryValue: 'Actions',
        stringKey: 'GRID_HEADER_ACTIONS',
    },
    GRID_HEADER_DATE: {
        description: 'Date',
        primaryValue: 'Date',
        stringKey: 'GRID_HEADER_DATE',
    },
    GRID_EMPTY_TEXT_PASS: {
        description: 'No passes found',
        primaryValue: 'No passes match the selected dropdown filters. Try adjusting the filters for more results or click on "Request a Pass".',
        stringKey: 'GRID_EMPTY_TEXT_PASS',
    },
    PASS_TYPE_COMP: {
        description: 'Comp Pass Type',
        primaryValue: 'Comp',
        stringKey: 'PASS_TYPE_COMP',
    },
    PASS_TYPE_VENDOR: {
        description: 'Vendor',
        primaryValue: 'Vendor',
        stringKey: 'PASS_TYPE_VENDOR',
    },
    PASS_TYPE_GUEST: {
        description: 'Guest',
        primaryValue: 'Guest',
        stringKey: 'PASS_TYPE_GUEST',
    },
    PASS_TYPE_VIP: {
        description: 'VIP',
        primaryValue: 'VIP',
        stringKey: 'PASS_TYPE_VIP',
    }
};

export default translations;
